import React, { useState, useEffect } from 'react'
import 'animate.css'
import { Row, Col } from 'antd'

import ScrollUpBtn from 'components/ScrollUpBtn'
import DetailContact from 'components/DetailContact'

import { httpClient } from 'core/util/httpClient'
import { enrollment, register } from 'core/schemas'

import studentComp from 'assets/images/png/student_comp-01.png'
import calendarSUT from 'assets/images/png/SUT-Calendar.png'
import bullet from 'assets/images/svg/bullet.svg'

import {
  Container,
  Title,
  TextSection,
  SubTitle,
  Href,
  BoxPrint,
} from './enrollment.style'

const Enrollment = () => {
  const [enrollmentData, setEnrollmentData] = useState([])
  const [service, setService] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
    
    getDataEnrollment()
    getDataService()
  }, [])
  

  const getDataEnrollment = async () => {
    const response = await httpClient.get(enrollment)

    if (response?.data?.code === 200) {
      const data = response?.data?.data

      setEnrollmentData(data?.section)
    } else {
      setEnrollmentData([])
    }
  }

  const getDataService = async () => {
    const response = await httpClient.get(register)

    if (response?.data?.code === 200) {
      const data = response?.data?.data
      const dataService = data?.section.filter(
        (item) => item?.slung === 'service-center',
      )

      setService(dataService)
    } else {
      setService([])
    }
  }

  const styleDetailContact = { marginBottom: '30px' }

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className='animate__animated animate__flipInX animate__slow'>
              {enrollmentData ? enrollmentData[0]?.title : 'การลงทะเบียนเรียน'}
            </Title>
          </Col>
          <Col span={24}>
            <Row gutter={24} className='row-section'>
              {enrollmentData &&
                enrollmentData[0]?.menu_data.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Href to={item?.slung}>
                        <div style={{ display: 'flex' }}>
                          <img
                          loading="lazy"
                            src={bullet}
                            alt='bullet icon'
                            style={{
                              width: '20px',
                              height: '20px',
                              margin: '10px 10px 0 0',
                            }}
                          />
                          <TextSection>
                            {item?.name === 'ศูนย์บริการนักศึกษา'
                              ? 'ศูนย์บริการการศึกษา'
                              : item?.name}
                          </TextSection>
                        </div>
                      </Href>
                    </Col>
                  )
                })}
            </Row>
          </Col>
        </Row>

        {enrollmentData && (
          <Row>
            <Col span={24}>
              {enrollmentData[1]?.link ? (
                <iframe
                  title='file'
                  style={{
                    width: '100%',
                    height: '760px',
                    marginTop: '20px',
                    border: 'none',
                  }}
                  src={enrollmentData[1]?.link}
                />
              ) : (
                <img
                loading="lazy"
                  src={
                    enrollmentData[1]?.media
                      ? enrollmentData[1]?.media
                      : calendarSUT
                  }
                  alt='table'
                  style={{ width: '100%', height: '100%', padding: '5px' }}
                />
              )}
            </Col>
          </Row>
        )}

        <SubTitle top='80' align='center'>
          {enrollmentData
            ? enrollmentData[2]?.title
            : 'ข้อมูลติดต่อศูนย์บริการนักศึกษา'}
        </SubTitle>
        <Row gutter={24} className='row-contanct'>
          <Col
            span={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {service && service?.image ? (
              <img
              loading="lazy"
                src={service?.image}
                alt='service'
                style={{
                  borderRadius: '20px',
                  width: '100%',
                  marginBottom: '25px',
                }}
              />
            ) : (
              <img
              loading="lazy"
                src={studentComp}
                alt='service'
                style={{
                  borderRadius: '20px',
                  width: '100%',
                  marginBottom: '25px',
                }}
              />
            )}
          </Col>

          <Col span={9} style={{ padding: '10px' }}>
            <div style={styleDetailContact}>
              <DetailContact
                phone={service && service[0]?.conent_0}
                time={`${service && service[0]?.conent_1} | ${
                  service && service[0]?.conent_2
                }`}
                website={service && service[0]?.conent_3}
              />
            </div>
          </Col>
          <Col span={9} style={{ padding: '10px' }}>
            <div style={styleDetailContact}>
              <DetailContact location={service && service[0]?.conent_4} />
            </div>
          </Col>
        </Row>
      </Container>

      <ScrollUpBtn />
    </>
  )
}

export default Enrollment
